/**
 * Release notice configuration for PolicyTrackr update notifications
 * Version: 2025-10-22-v1
 *
 * HOW IT WORKS:
 * 1. On app load, checks if today's date matches the release date in releaseNotice.js
 * 2. If it matches and no localStorage entry exists for today, shows the modal
 * 3. When user closes the modal, saves today's date to localStorage
 * 4. Modal won't show again that day, even after page refresh or in new tabs
 *
 * TESTING:
 * 1. Open the app - modal should appear if today matches the release date
 * 2. Close the modal - check localStorage: policytrackr_notice_shown_date should be set
 * 3. Refresh the page - modal should NOT appear again
 * 4. Open in new tab - modal should NOT appear (localStorage is shared)
 * 5. Next day or when you update the date in releaseNotice.js - modal will appear again
 *
 * TO UPDATE FOR NEW RELEASE:
 * 1. Update the date, version, title, and summary in src/data/releaseNotice.js
 * 2. The modal will automatically show on the new specified date
 *
 * MANUAL TESTING:
 * Open browser console and run:
 * localStorage.removeItem('policytrackr_notice_shown_date');
 * Then refresh the page to see the modal again.
 */

export const releaseNotice = {
  date: "2026-03-16",               // release date or unique identifier
  //version: "v2.1.0",                  // optional, for manual re-show triggers
  title: "New Export & Import Features!",
  summary: [
    "Export policy data with custom filters.",
    "Import your existing client directly from Excel sheets."
  ]
};

/**
 * Test utility function for debugging the release modal
 */
export const testReleaseModal = () => {
  console.log('Current localStorage:', localStorage.getItem('policytrackr_notice_shown_date'));
  console.log('Today:', new Date().toISOString().split('T')[0]);
  console.log('Release date:', releaseNotice.date);
  console.log('Should show modal:', localStorage.getItem('policytrackr_notice_shown_date') !== new Date().toISOString().split('T')[0] && new Date().toISOString().split('T')[0] === releaseNotice.date);
};
